module.exports = __webpack_public_path__ + "img/team-16.bd53ba0a.jpg";